import React from 'react';
import {Button} from 'antd';
import {BsThreeDotsVertical} from 'react-icons/bs';
import {useIntl} from 'react-intl';

// The ⋯ that opens a table row's actions menu: a quiet icon that gets a
// soft circle on hover, instead of a filled button on every row. Dropdown
// passes its trigger props and a ref, so both are forwarded to the button.
const RowActionsButton = React.forwardRef<HTMLElement, any>((props, ref) => {
  const {messages} = useIntl();
  return (
    <Button
      {...props}
      ref={ref}
      type='text'
      shape='circle'
      className='row-actions-btn'
      aria-label={messages['common.Action'].toString()}
      icon={<BsThreeDotsVertical />}
    />
  );
});

export default RowActionsButton;
